import { useContext, useEffect, useRef, useState } from 'react';
import { Container, Navbar } from 'react-bootstrap';
import { ErrorBoundary } from 'react-error-boundary';
import { useHistory, useParams } from 'react-router-dom';
import { Column, Row } from '../../../components';
import AppContext from '../../../shared/components/AppContext';
import { FallbackComponent } from '../../../shared/components/FallbackComponent';
import { useConfirmationModalContext } from '../../../shared/components/ModalConfirmationContext';
import * as constant from '../../../shared/util/constant';
import { AgencySetupLabels } from '../../../shared/util/label';
import AgencySetup from '../AgencySetup/AgencySetup';
import AgencySideBar from '../AgencySlideBar/AgencySideBar';
import { Button } from 'react-bootstrap';
import { AbilityContext } from '../../../shared/abilities/AbilityContext';

const AgencySetupMain = () => {
    const ability = useContext(AbilityContext);
    const canCreate = ability.can('create', constant.MaintenanceSubject, constant.MaintenanceScreenPrivileges.Agency_Setup);
    const canUpdate = ability.can('update', constant.MaintenanceSubject, constant.MaintenanceScreenPrivileges.Agency_Setup);
    const canDelete = ability.can('delete', constant.MaintenanceSubject, constant.MaintenanceScreenPrivileges.Agency_Setup);
    const { groupId } = useParams<{ groupId: string | undefined }>();
    const [selectedGroupId, setSelectedGroupId] = useState<string>(null);
    const [showGroupDetailsOnLoad, setShowGroupDetailsOnLoad] = useState<boolean>(false);
    const modalContext = useConfirmationModalContext();
    const privielgeContext = useContext(AppContext);
    const [newGroupButton, setNewGroupButton] = useState(false);

    const handleChildStateChange = (childState: boolean) => {
        setNewGroupButton(childState);
    };

    const [reloadSidebar, setReloadSidebar] = useState(false);
    const history = useHistory();

    // Handle when user try to click on new group button
    const handleNewGroupClick = async () => {
        if (!privielgeContext.formSavedStatus) {
            const result = await modalContext.showConfirmation(constant.CONFIRM_EXIT)
            if (result) {
                setSelectedGroupId(null);
                setShowGroupDetailsOnLoad(true);
                privielgeContext.formSavedStatus = true
                history.push(`/maintenance/agency`);
            }
        }
        else {
            setNewGroupButton(true);
            setSelectedGroupId(null);
            setShowGroupDetailsOnLoad(true);
            history.push(`/maintenance/agency`);
        }
    };

    const handleCancelClick = async () => {
        setNewGroupButton(false);
        setSelectedGroupId(null);
        setShowGroupDetailsOnLoad(false);
        setReloadSidebar(!reloadSidebar)
        history.push(`/maintenance/agency`);

    }

    const handleSave = async () => {
        setShowGroupDetailsOnLoad(false);
        setReloadSidebar(!reloadSidebar)
        history.push(`/maintenance/agency`);
    };

    useEffect(() => {
        if (groupId) {
            setSelectedGroupId(groupId);
            setShowGroupDetailsOnLoad(true);
        }
    }, [groupId]);

    return (
        <>
            <Container fluid className='px-4'>
                <Row className="role-privilege-main">
                    <Column lg={12} md={12}>
                        <ErrorBoundary FallbackComponent={FallbackComponent}>
                            <Row>
                                <Column lg={9}>
                                    <Navbar className="bg-transparent">
                                        <Navbar.Brand>Agency Setup</Navbar.Brand>
                                        <Button id={"newGroup"} className='ms-auto' disabled={newGroupButton || !canCreate} color='primary' style={{ marginRight: "20px" }} onClick={handleNewGroupClick}>
                                            {AgencySetupLabels.NEW_GROUP} </Button>
                                    </Navbar>
                                </Column>
                            </Row>
                            <Container fluid>
                                <Row>
                                    <Column lg={12} className='role-details'>
                                        <Row>
                                            <Column lg={3} className='roles-sidebar ps-0'>
                                                <ErrorBoundary FallbackComponent={FallbackComponent}>
                                                    <div className={`active card shadow-sm`}>
                                                        <AgencySideBar onStateChange={handleChildStateChange} reload={reloadSidebar} />
                                                    </div>
                                                </ErrorBoundary>
                                            </Column>
                                            {showGroupDetailsOnLoad &&
                                                <Column lg={9} className={'screen-privilege'}>
                                                    <ErrorBoundary FallbackComponent={FallbackComponent}>
                                                        <div className='p-0'>
                                                            <AgencySetup onStateChange={handleChildStateChange} groupId={selectedGroupId} onCancel={handleCancelClick} onSave={handleSave} onDelete={handleCancelClick} canCreate={canCreate} canUpdate={canUpdate} canDelete={canDelete} />
                                                        </div>
                                                    </ErrorBoundary>
                                                </Column>
                                            }

                                        </Row>
                                    </Column>
                                </Row>
                            </Container>
                        </ErrorBoundary>
                    </Column>
                </Row>
            </Container>

        </>
    )
}

export default AgencySetupMain;